'use es6';

import WithBusinessUnitsDataFetching from 'ui-business-units-lib/utils/WithBusinessUnitsDataFetching';
import EmailTypeSelectModalBody from 'EmailComponents/emailCreation/EmailTypeSelectModalBody';
import { jsx as _jsx } from "react/jsx-runtime";
const EmailTypeSelectWithDataFetching = WithBusinessUnitsDataFetching(EmailTypeSelectModalBody);
function EmailTypeSelectModalBodyWithBusinessUnit(props) {
  const {
    canAccessBusinessUnit
  } = props;
  if (!canAccessBusinessUnit) {
    return /*#__PURE__*/_jsx(EmailTypeSelectModalBody, Object.assign({}, props));
  }
  return /*#__PURE__*/_jsx(EmailTypeSelectWithDataFetching, Object.assign({}, props));
}
export default EmailTypeSelectModalBodyWithBusinessUnit;